import "./style.scss";
import "./style-mob.scss";
import { useState } from "react";
import Tabs from "@/src/components/Tabs/Tabs";
import AdmissionProcessSteps from "./AdmissionProcessSteps/AdmissionProcessSteps";
import { admissionProcessTabs } from "@/src/constants/admission-process";
import {
  admissionProcessStepsOnCampus,
  admissionProcessStepsOnline,
  admissionProcessStepsShortCourses,
} from "@/src/constants/admission-process";
import ReadMoreBtn from "@/src/components/ReadMoreBtn/ReadMoreBtn";
import { Link } from "react-router-dom";

const AdmissionProcess = () => {
  const [currentTab, setCurrentTab] = useState<string>("on-campus");

  return (
    <div className="admission-process container section-margin-top">
      <div className="admission-process-header">
        <Tabs
          title="Admission Process"
          tabs={admissionProcessTabs}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />
      </div>
      {currentTab === "on-campus" && (
        <AdmissionProcessSteps steps={admissionProcessStepsOnCampus} />
      )}
      {currentTab === "online" && <AdmissionProcessSteps steps={admissionProcessStepsOnline} />}
      {currentTab === "short-courses" && (
        <AdmissionProcessSteps steps={admissionProcessStepsShortCourses} />
      )}
      <ReadMoreBtn text="Read More →" link="#" className="admission-process-read-more-btn" />
      <div className="admission-process-mobile-btns">
        <Link to="/" className="admission-process-mobile-btn apply-online">
          Apply online →
        </Link>
        <Link to="/" className="admission-process-mobile-btn read-more">
          read More →
        </Link>
      </div>
    </div>
  );
};

export default AdmissionProcess;
